import angular from 'angular';
import productDetailComponent from './product-detail.component';
import ProductDetailService from './product-detail.service';
import productDetailConfig from './product-detail.config';

let productDetailModule = angular.module('productDetail',[])
  .component('productDetail', productDetailComponent)
  .service('ProductDetailService', ProductDetailService)
  .config(productDetailConfig);

export default productDetailModule;



/** WEBPACK FOOTER **
 ** ./www/components/catalog/product-detail/product-detail.js
 **/